import React from "react";
import { BrowserRouter,Routes, Route,} from "react-router-dom";
import AddPost from "./AdminPage/AddPost/addPost";
import Homepage from "./Homepage/Homepage";
import PendingEvents from "./AdminPage/ManageOptions/PendingEvents/PostStatus";
import Login from "./Login/login";
import ManageUser from "./AdminPage/ManageOptions/ManageUsers/ManageUser";
import AddPostWrapper from "./AdminPage/AddPost/addPostWrapper";
import HomepageWrapper from "./Homepage/Homepagewrapper";
import EventDetailsWrapper from "./AdminPage/EventDetails/EventDetailswrapper";
import SavedPostWrapper from "./User/savedPostWrapper";
import ReviewPostWrapper from "./AdminPage/ReviewPost/ReviewPostWrapper";
import ManageCategoriesWrapper from "./AdminPage/ManageOptions/ManageCategories/ManageCategoriesWrapper";
import ManageGuideWrapper from "./AdminPage/ManageOptions/ManageGuides/ManageGuidesWrapper";
import AdminAnalytics from "./AdminPage/ManageOptions/AdminAnalytics/adminAnalytics";


function App() {
    return (
        <>
            {/* <BrowserRouter> */}
                <Routes>
                    <Route exact path="/Add-Post" element={<AddPostWrapper/>}/>
                    <Route exact path="/login" element={<Login/>}/>
                    <Route exact path="/" element={<Homepage/>}/>
                    <Route exact path="/event/:id" element={<EventDetailsWrapper/>}/>
                    <Route exact path="/Homepage" element={<HomepageWrapper/>}/>
                    <Route path="/Pending-Events" element={<PendingEvents />} />
                    <Route exact path="/Manage-User" element={<ManageUser/>}/>
                    <Route exact path="/Saved-Events" element={<SavedPostWrapper/>}/>
                    <Route exact path="/Review-Posts" element={<ReviewPostWrapper/>}/>
                    <Route exact path="/Manage-Categories" element={<ManageCategoriesWrapper/>}/>
                    <Route exact path="/College-Counseling-Resources" element={<ManageGuideWrapper/>}/>
                    <Route exact path="/Admin-Analytics" element={<AdminAnalytics/>}/>


                    
                </Routes>
            {/* </BrowserRouter> */}
        </>
    );
}
export default App;